import { compose, pure } from 'recompose';
import { withTranslation } from 'react-i18next';
import DraggableOverlay from './draggableOverlay';

const enhance = compose(
  pure,
  withTranslation(['tasks']),
);
export default enhance(DraggableOverlay);
